"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _Modal = _interopRequireDefault(require("../common/Modal/Modal"));
var _APLabelWithText = _interopRequireDefault(require("../common/APLabelWithText"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _orderEntryFormConstants = require("../../constants/sendOrder/orderEntryFormConstants");
var _numberFormatter = require("../../helpers/numberFormatter");
var _orderHelper = require("../../helpers/orderHelper");
require("./ConfirmOrderModalComponent.css");
var _pegPriceTypeConstants = require("../../constants/sendOrder/pegPriceTypeConstants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('confirm-order-modal');
var ConfirmOrderModalComponent = function ConfirmOrderModalComponent(props) {
  var _formObj$values$fee, _formObj$values$fee2;
  var _useTranslation = (0, _reactI18next.useTranslation)('order'),
    t = _useTranslation.t;
  var formObj = props.formObj,
    isOpen = props.isOpen,
    close = props.close,
    confirmReport = props.confirmReport,
    feeSymbol = props.feeSymbol,
    selectedInstrument = props.selectedInstrument,
    price = props.price,
    orderTotal = props.orderTotal,
    isMarginActive = props.isMarginActive,
    level1 = props.level1,
    leverage = props.leverage,
    isFuturesActive = props.isFuturesActive,
    futuresFormValues = props.futuresFormValues,
    confirmFuturesOrder = props.confirmFuturesOrder,
    product1DecimalPlaces = props.product1DecimalPlaces,
    product2DecimalPlaces = props.product2DecimalPlaces,
    quantityDP = props.quantityDP,
    valueDP = props.valueDP,
    futuresAmount = props.futuresAmount,
    futuresValue = props.futuresValue,
    futuresOrderCost = props.futuresOrderCost;
  var Product1Symbol = selectedInstrument.Product1Symbol,
    Product2Symbol = selectedInstrument.Product2Symbol;
  var isBuySide = formObj.values.side === _orderEntryFormConstants.buyValue;
  var isMarketByValue = formObj.values.anchoredField === 'value';
  var _ref = futuresFormValues || {},
    futuresOrderSide = _ref.side,
    futuresOrderType = _ref.orderType,
    futuresTriggerPrice = _ref.triggerPrice,
    futuresTakeProfit = _ref.takeProfit,
    futuresStopLoss = _ref.stopLoss,
    _ref$timeInForce = _ref.timeInForce,
    timeInForce = _ref$timeInForce === void 0 ? 'GTC' : _ref$timeInForce,
    priceOrderType = _ref.priceOrderType,
    TPSL = _ref.TPSL;
  var futuresTimeInForceMap = {
    GTC: 'Good-Till-Canceled',
    IOC: 'Immediate-Or-Cancel',
    FOK: 'Fill-Or-Kill'
  };
  var futuresTimeInForce = futuresTimeInForceMap[timeInForce] || timeInForce;
  var isTrailing = [_orderEntryFormConstants.orderTypes.trailingStopLimit, _orderEntryFormConstants.orderTypes.trailingStopMarket].some(function (o) {
    return o.displayName === formObj.values.orderType;
  });
  var items = [{
    label: "".concat(t('Order Type'), ":"),
    text: formObj.values.orderType
  }, {
    label: "".concat(t('Quantity'), ":"),
    text: "".concat((0, _numberFormatter.formatNumberToLocale)(formObj.values.quantity, product1DecimalPlaces), " ").concat(Product1Symbol)
  }, isTrailing ? {
    label: "".concat(t('Trailing Amount'), ":"),
    text: "".concat((0, _numberFormatter.formatNumberToLocale)(formObj.values.trailingAmount, product2DecimalPlaces), " ").concat(Product2Symbol)
  } : {
    label: formObj.values.orderType === 'Stop Market' || formObj.values.orderType === 'Stop Limit' ? "".concat(t('Stop Price'), ":") : "".concat(t('Price'), ":"),
    text: isMarginActive && formObj.values.orderType === 'Market Order' ? 'Market' : "".concat((0, _numberFormatter.formatNumberToLocale)(price, product2DecimalPlaces), " ").concat(Product2Symbol)
  }, formObj.values.orderType === 'Stop Limit' && {
    label: "".concat(t('Limit Price'), ":"),
    text: isMarginActive && formObj.values.orderType === 'Market Order' ? 'Market' : "".concat((0, _numberFormatter.formatNumberToLocale)(formObj.values.limitPrice, product2DecimalPlaces), " ").concat(Product2Symbol)
  }, formObj.values.orderType === _orderEntryFormConstants.orderTypes.trailingStopLimit.displayName && {
    label: "".concat(t('Limit Offset'), ":"),
    text: "".concat((0, _numberFormatter.formatNumberToLocale)(formObj.values.limitOffset, product2DecimalPlaces), " ").concat(Product2Symbol)
  }, isTrailing && {
    label: "".concat(t('Peg Price'), ":"),
    text: _pegPriceTypeConstants.pegPriceTypesNames[formObj.values.pegPriceType]
  }, {
    label: "".concat(t('Fee'), ":"),
    text: "".concat((0, _numberFormatter.formatNumberToLocale)((_formObj$values$fee = formObj.values.fee) === null || _formObj$values$fee === void 0 ? void 0 : _formObj$values$fee.OrderFee, feeSymbol), " ").concat(feeSymbol)
  }, isMarketByValue && formObj.values.side === '0' || isMarginActive && formObj.values.orderType === 'Market Order' || isMarginActive && formObj.values.orderType === 'Limit Order' ? null : {
    label: "".concat(t('Value'), ":"),
    text: "".concat((0, _numberFormatter.formatNumberToLocale)(orderTotal, product2DecimalPlaces), " ").concat(Product2Symbol)
  }];
  if (isMarginActive) {
    if (formObj.values.orderType === 'Stop Market') {
      items.splice(1, 0, {
        label: "".concat(t('Leverage', {
          ns: 'margin'
        }), ":"),
        text: "".concat(leverage, "x")
      });
    } else {
      items.push({
        label: "".concat(t('Net Receiving', {
          ns: 'margin'
        }), ":"),
        text: "".concat((0, _orderHelper.getOrderNet)(formObj.values, selectedInstrument, orderTotal, formObj.values.anchoredField, level1, true, isMarginActive, isBuySide ? product1DecimalPlaces : product2DecimalPlaces))
      }, {
        label: "".concat(t('Order Total', {
          ns: 'margin'
        }), ":"),
        text: "".concat((0, _numberFormatter.formatNumberToLocale)(orderTotal, product2DecimalPlaces), " ").concat(Product2Symbol)
      });
    }
  }
  var getPriceText = function getPriceText() {
    if (futuresOrderType === 'Limit') return "".concat((0, _numberFormatter.formatNumberToLocale)(formObj.values.limitPrice, valueDP), " ").concat(Product2Symbol);
    if ([futuresOrderType, priceOrderType].includes('Market')) return 'Market';
    return "".concat((0, _numberFormatter.formatNumberToLocale)(price, valueDP), " ").concat(Product2Symbol);
  };
  var futuresItems = [{
    label: "".concat(t('Order Type'), ":"),
    text: futuresOrderType
  }, {
    label: "".concat(t('Amount'), ":"),
    text: "".concat((0, _numberFormatter.formatNumberToLocale)(futuresAmount, quantityDP), " ").concat(selectedInstrument === null || selectedInstrument === void 0 ? void 0 : selectedInstrument.Product1Symbol)
  }, {
    label: "".concat(t('Value'), ":"),
    text: "".concat((0, _numberFormatter.formatNumberToLocale)(futuresValue, valueDP), " ").concat(selectedInstrument === null || selectedInstrument === void 0 ? void 0 : selectedInstrument.Product2Symbol)
  }, futuresOrderType === 'Conditional' && {
    label: "".concat(t('Trigger Price'), ":"),
    text: "".concat((0, _numberFormatter.formatNumberToLocale)(futuresTriggerPrice, valueDP), " ").concat(Product2Symbol)
  }, {
    label: "".concat(t('Price'), ":"),
    text: getPriceText()
  }, TPSL && futuresTakeProfit && {
    label: "".concat(t('Take Profit'), ":"),
    text: "".concat((0, _numberFormatter.formatNumberToLocale)(futuresTakeProfit, valueDP), " ").concat(Product2Symbol)
  }, TPSL && futuresStopLoss && {
    label: "".concat(t('Stop Loss'), ":"),
    text: "".concat((0, _numberFormatter.formatNumberToLocale)(futuresStopLoss, valueDP), " ").concat(Product2Symbol)
  },
  // Don't think BE has estimated liquidation price ready yet
  {
    label: "".concat(t('Estim. Liquid. Price'), ":"),
    text: "".concat((0, _numberFormatter.formatNumberToLocale)((_formObj$values$fee2 = formObj.values.fee) === null || _formObj$values$fee2 === void 0 ? void 0 : _formObj$values$fee2.OrderFee, valueDP), " ").concat(feeSymbol)
  }, {
    label: "".concat(t('Leverage'), ":"),
    text: "".concat(leverage, "x")
  }, (futuresOrderType === 'Limit' || futuresOrderType === 'Conditional') && {
    label: "".concat(t('Time in Force'), ":"),
    text: futuresTimeInForce
  }, {
    label: "".concat(t('Cost'), ":"),
    text: "".concat((0, _numberFormatter.formatNumberToLocale)(futuresOrderCost, valueDP), " ").concat(Product2Symbol)
  }].filter(Boolean);
  var itemsToDisplay = isFuturesActive ? futuresItems : items;
  var standardTitle = isBuySide ? t('Confirm Buy Order') : t('Confirm Sell Order');
  var futuresTitle = futuresOrderSide === '0' ? t("Confirm Long ".concat(selectedInstrument.Symbol)) : t("Confirm Short ".concat(selectedInstrument.Symbol));
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: isOpen,
    title: isFuturesActive ? futuresTitle : standardTitle,
    close: close,
    footer: {
      buttonText: t('Submit'),
      buttonStyle: isBuySide || isFuturesActive ? 'additive' : 'subtractive',
      onClick: function onClick() {
        if (isFuturesActive) {
          confirmFuturesOrder(futuresFormValues);
        } else {
          confirmReport(formObj.values);
        }
      }
    },
    customClass: bemClasses(formObj.values.side === _orderEntryFormConstants.buyValue ? 'bought' : 'sold')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses()
  }, itemsToDisplay.filter(function (i) {
    return i;
  }).map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
      key: item.label,
      label: item.label,
      text: item.text,
      customClass: bemClasses()
    });
  })));
};
var _default = exports["default"] = ConfirmOrderModalComponent;